<template>
  <div>
    <!-- 첫 번째 행: Your Organization's Material History -->
    <b-row>
      <b-col>
        <div>
          <b-card style="background-image: url('img/bg/data-background-facility.svg')">
            <b-card-body style="max-width: 18rem; background-color: white">
              <b-card-sub-title class="mb-2">Your Organization's Material History</b-card-sub-title>
              <b-card-text>
                <h1>{{ page.totalElements }}</h1>
              </b-card-text>
            </b-card-body>
          </b-card>
        </div>
      </b-col>
    </b-row>

    <!-- 두 번째 행: Delivered Products와 GoogleMap -->
    <b-row class="equal-height-columns">
      <b-col sm="8" class="d-flex flex-column mb-4 left-panel" ref="leftCol">
        <b-card class="flex-grow-1">
          <b-card-header>
            <h4>Delivered Products</h4>
          </b-card-header>
          <b-card-body ref="leftPanel">
            <b-input-group class="mb-3">
              <b-form-input v-model="filter" placeholder="검색어를 입력하세요"></b-form-input>
              <b-input-group-append>
                <b-button @click="resetFilter">초기화</b-button>
              </b-input-group-append>
            </b-input-group>
            <b-table 
              striped
              hover
              :items="productPageQuery"
              :fields="fields"
              @row-clicked="onRowClick"
              :per-page="perPage"
              :current-page="currentPage"
              responsive="sm"
              class="mb-0 clickable-rows"
            ></b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="table-data"
              class="mt-2"
            ></b-pagination>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="4" class="d-flex flex-column mb-4 right-panel" ref="rightPanel">
        <b-card no-body class="flex-grow-1">
          <b-card-body class="p-0">
            <GoogleMap ref="googleMapComponent" :mapHeight="mapHeight" :markers="markers"/>
             <!-- <GoogleEarthComponent/> -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- 세 번째 행: List of raw materials -->
    <b-row>
      <b-col sm="12">
        <b-card>
          <b-card-header>
            <h4>List of raw materials</h4>
          </b-card-header>
          <b-card-body>
            <b-skeleton-wrapper :loading="loading">
              <template #loading>
                <b-skeleton-table
                  :rows="rows2"
                  :columns="rawMaterialsFields.length"
                  :table-props="{ bordered: true, striped: true }"
                >
                </b-skeleton-table>
              </template>
              <b-table striped hover :items="rawMaterialsData" :fields="rawMaterialsFields" responsive="sm"  tbody-tr-class="clickable-row">
                <template #cell(materialLot)="row">
                  <b-link @click="fetchMaterialDeliveryInfo(row.item)">
                    {{ row.item.materialLot }}
                  </b-link>
                </template>
              </b-table>
              </b-skeleton-wrapper>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- 원재료 배송 정보 모달 -->
    <b-modal id="material-delivery-info-modal" title="원재료 추적 정보" size="xl" @hide="clearMaterialDeliveryInfo">
      <b-table striped hover :items="materialDeliveryData" :fields="deliveryFields" responsive="sm"></b-table>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import GoogleMap from '../googlemap/GoogleMap.vue';

export default {
  name: 'TraceNavigate',
  components: {
    GoogleMap
  },
  data() {
    return {
      loading: false,
      totalRows: 1,
      fields: [
        { key: 'eventTime', label: '배송일', formatter: value => moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss')},
        { key: 'facility.facilityName', label: '출발지' },
        { key: 'product.productName', label: '생산완료제품' },
        { key: 'epc', label: 'GTIN(생산완료제품)' },
        { key: 'batchOrLot', label: 'LOT(생산완료제품)' },
        { key: 'orderNumber', label: '주문번호(생산완료제품)' },
        { key: 'quantity', label: '수량' }
      ],
      productItems: [],
      filter: '',
      currentPage: 1,
      perPage: 5,
      page: {},
      rawMaterialsFields: [
        { key: 'materialName', label: '원재료명' },
        { key: 'materialLot', label: 'LOT(원재료제품)' },
        { key: 'materialProductionDate', label: '원재료생산일자', formatter: value => moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss') },
        
        { key: 'materialGtin', label: 'GTIN(원제료제품)' },
        { key: 'productName', label: '제품명' },
        { key: 'productLot', label: 'LOT(생산완료제품)' },
        { key: 'gtin', label: 'GTIN(생산완료제품)' },
        { key: 'productionDate', label: '생산일자', formatter: value => moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss') },
        { key: 'totalQuantity', label: '사용수량' },
        
      ],
      rawMaterialsData: [],
      deliveryFields: [
        
        { key: 'eventTime', label: '이벤트일시' , formatter: value => moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss')},
        // { key: 'productName', label: '원재료' },
        { key: 'facilityName', label: '위치' },
        { key: 'bizStep', label: 'bizStep' },
        { key: 'disposition', label: '상태' },
        // { key: 'productName', label: '원재료' },
        { key: 'lotNumber', label: 'LOT(원재료)' },
        { key: 'epc', label: 'SSCC(원재료)' }
      ],
      materialDeliveryData: [],
      mapHeight: 450,
      markers: []
    };
  },
  mounted() {
    this.updateMapHeight();
    window.addEventListener('resize', this.updateMapHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMapHeight);
  },
  created() {
    this.$_loadingTimeInterval = null;
  },
  methods: {
    clearLoadingTimeInterval() {
      clearInterval(this.$_loadingTimeInterval);
      this.$_loadingTimeInterval = null;
    },
    updateMapHeight() {
      const leftPanel = this.$refs.leftPanel;
      const leftCol = this.$refs.leftCol;
      if (leftPanel) {
        this.$nextTick(() => {
          const googleMapComponent = this.$refs.googleMapComponent;
          if (googleMapComponent) {
            const pHeight = leftPanel.clientHeight < 500 ? 500 : leftPanel.clientHeight;
            setTimeout(() => {
              this.mapHeight = pHeight + 50
              googleMapComponent.resizeMap(pHeight + 50);
            }, 300); // 1초 후에 스크립트 로드 시도
          }
        });
      }
    },
    async productPageQuery(ctx) {
      this.loading = true;
      let page = ctx.currentPage;
      let size = ctx.perPage;
      const productRes = await this.$traceApi.get(`api/productions/paged?page=${page}&size=${size}`);
      this.page = productRes.data.page;
      this.rawMaterialsData = []
      this.markers = []
      if(productRes.data._embedded) {
        return productRes.data._embedded.cretedProductList;
      }else {
        return []
      }
      
    },
    async onRowClick(item) {
      // this.rawMaterialsData = [];
      this.loading = true;
      try {
        const rawMaterialsRes = await this.$traceApi.get(`api/productions/${item.eventId}/materials`);
        this.rawMaterialsData = rawMaterialsRes.data.materials;
        const facilities = rawMaterialsRes.data.facilities;
        const markersRes = await this.$traceApi.post(`api/productions/markers`, {facilities});
        this.markers = markersRes.data.map(marker => ({
          id: marker.id,
          position: { lat: marker.latitude, lng: marker.longitude },
          facility_name: marker.facilityName,
          image: 'img/bg/data-background-facility.svg',
          created_dt: marker.createdDt,
          updated_dt: marker.updatedDt,
          city: marker.city,
          country: marker.country,
          facility_id: marker.facilityId,
          facility_id_type: marker.facilityIdType,
          facility_type: marker.facilityType,
          postal_code: marker.postalCode,
          state: marker.state,
          street_address: marker.streetAddress,
          organization_id: marker.organizationId,
          gln: marker.gln,
          facility_code: marker.facilityCode,
          opened: false
        }));
      } finally {
        // this.loading = false;
        this.$nextTick(() => {
          this.updateMapHeight(); // 테이블 데이터 로드 후 높이 갱신
        });
      }
    },
    fetchMaterialDeliveryInfo(materialLot) {
      this.materialDeliveryData = this.generateSingleMaterialDeliveryData(materialLot);
      this.$bvModal.show('material-delivery-info-modal');
    },
    async generateSingleMaterialDeliveryData(materialLot) {
      try {
        const transformationLogRes = await this.$traceApi.get(`api/productions/materials/logs/${materialLot.transformationLogId}`);
        console.log(transformationLogRes.data)

        this.materialDeliveryData = transformationLogRes.data.map(tl => {
          tl.bizStep = tl.bizStep.replace('urn:epcglobal:cbv:bizstep:', '');
          tl.disposition = tl.disposition.replace('urn:epcglobal:cbv:disp:', '');
          tl.epc = tl.epc.replace('urn:epc:id:class:', '')
          console.log(tl)
          return tl;
        });


      }catch(e){
        console.error(e)
      }
      return [];
    },
    clearMaterialDeliveryInfo() {
      this.materialDeliveryData = [];
    },
    resetFilter() {
      this.filter = '';
    }
  },
  computed: {
    rows() {
      return this.page.totalElements;
    },
    rows2() {
      return this.rawMaterialsData.length == 0? 1 : this.rawMaterialsData.length;
    }
  },
  watch: {
    loading(newValue, oldValue) {
      
      if (newValue !== oldValue) {
        this.clearLoadingTimeInterval();
        if (newValue) {
          this.$_loadingTimeInterval = setInterval(() => {
            this.loading = false;
            // this.onComplate = true;
          }, 700);
        }
      }
    },
  },
};
</script>

<style scoped>
.equal-height-columns {
  display: flex;
}

.left-panel {
  display: flex;
  flex-direction: column;
}

.right-panel {
  display: flex;
  flex-direction: column;
}

.clickable-rows tbody tr {
  cursor: pointer;
}
.clickable-row {
    cursor: pointer;
}
</style>
